import * as vp from 'vopay';
import { Box, Select } from 'vopay';
import React, { FunctionComponent, useMemo, useState } from 'react';
import { Button } from 'UI';
import { useTranslation } from 'react-i18next';

type ActivitySummaryFormProps = {
  initValues?: { Year: string; Month: string };
  search: (values: vp.PartnerAccountSummaryRequest) => void;
};
type FC = FunctionComponent<ActivitySummaryFormProps>;

const ActivitySummaryForm: FC = ({ initValues, search }: ActivitySummaryFormProps) => {
  const STARTING_YEAR = 2021;
  const yearSelectOptions = useMemo(() => buildYearSelectOptions(STARTING_YEAR), []);
  const [Year, setYear] = useState(initYear());
  const [Month, setMonth] = useState(initMonth());
  const { t } = useTranslation('translations', { keyPrefix: 'Reports.ActivitySummaryList' });

  const monthOptions = Object.entries(vp.NUMERIC_MONTH_OPTIONS)
    .sort(([a], [b]) => Number(a) - Number(b))
    .map(([value, label]) => ({ label, value }));

  const handleYearChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setYear(event.currentTarget.value);
  };

  const handleMonthChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setMonth(event.currentTarget.value);
  };

  return (
    <Box flx="row" ai="center" gap="sm">
      <Box gap="sm">
        <Select
          version="2"
          options={monthOptions}
          placeholder={t('monthPlaceholder')}
          name="invoice-month-select"
          value={Month}
          onBlur={() => {}}
          onChange={handleMonthChange}
          sort={false}
        />
        <Select
          version="2"
          options={yearSelectOptions}
          placeholder={t('yearPlaceholder')}
          name="invoice-year-select"
          value={Year}
          onBlur={() => {}}
          onChange={handleYearChange}
        />
      </Box>
      <Button id="display-invoice-period" size="small" colorScheme="primary" onClick={() => search({ Year, Month })}>
        {t('searchButton')}
      </Button>
    </Box>
  );

  function initYear() {
    const y = initValues?.Year || '';
    return yearSelectOptions.some((opt) => opt.value === y) ? y : '';
  }

  function initMonth() {
    const m = initValues?.Month || '';
    return Object.prototype.hasOwnProperty.call(vp.NUMERIC_MONTH_OPTIONS, m.padStart(2, '0')) ? m.padStart(2, '0') : '';
  }

  function buildYearSelectOptions(startingYear: number) {
    const currentYear = new Date().getFullYear();
    return Array.from({ length: currentYear - startingYear + 1 }, (_, i) => {
      const year = currentYear - i;
      return { label: String(year), value: String(year) };
    });
  }
};

export default ActivitySummaryForm;
